import { Box, Flex, Heading } from 'rebass'
import { BoxSection, FlexSection } from '../components/section'
import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import CV from '../components/cv'
import Color from 'color'
import ContactForm from '../components/contact-form'
import DetailedMap from '../assets/map.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Hours from '../components/hours'
import { I18n } from '@lingui/react'
import Img from 'gatsby-image'
import Layout from '../components/layout'
import LazyLoad from 'react-lazyload'
import Map from '../components/map'
import Obfuscate from 'react-obfuscate'
import Pricing from '../components/pricing'
import { Trans } from '@lingui/macro'
import { Transition } from 'react-transition-group'
import typography from '../utils/typography'

const IndexPage = ({ pageContext: { locale }, location }) => {
  const {
    allHoursHygieneYaml: { edges: hoursHygiene },
    allHoursYaml: { edges: hours },
    buildingExterior,
    clinicInterior,
    diana,
    erika,
    ondrej,
  } = useStaticQuery(graphql`
    {
      buildingExterior: file(
        relativePath: { eq: "images/building-exterior.jpg" }
      ) {
        id
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      clinicInterior: file(relativePath: { eq: "images/clinic-interior.jpg" }) {
        id
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      ondrej: file(relativePath: { eq: "images/ondrej.tiff" }) {
        childImageSharp {
          fluid(toFormat: JPG) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      erika: file(relativePath: { eq: "images/erika.tiff" }) {
        childImageSharp {
          fluid(toFormat: JPG) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      diana: file(relativePath: { eq: "images/diana.tiff" }) {
        childImageSharp {
          fluid(toFormat: JPG) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      allHoursYaml {
        edges {
          node {
            id
            day
            from {
              hours
              minutes
            }
            to {
              hours
              minutes
            }
          }
        }
      }

      allHoursHygieneYaml {
        edges {
          node {
            id
            day
            from {
              hours
              minutes
            }
            to {
              hours
              minutes
            }
          }
        }
      }
    }
  `)

  const carouselImages = [clinicInterior, buildingExterior]
  const [carouselIndex, shiftCarouselIndex] = useState(0)

  setTimeout(() => {
    shiftCarouselIndex(
      carouselImages[carouselIndex + 1] ? carouselIndex + 1 : 0
    )
  }, 11111)

  const carouselTransitionDuration = 2222

  const carouselTransitionStyles = {
    entering: { opacity: 1 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
  }

  return (
    <Layout locale={locale} location={location}>
      <I18n>
        {({ i18n }) => (
          <>
            <FlexSection
              id="intro"
              mergeCss={{
                position: 'relative',
                minHeight: '100vh',
                '&:before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  background: Color('black').fade(0.66),
                },
                '@media (min-width: 992px)': {
                  marginTop: '-25vw',
                  paddingTop: '8vw',
                },
              }}
            >
              {carouselImages.map(({ id, childImageSharp }, index) => {
                return (
                  <Box
                    key={id}
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      zIndex: -1,
                    }}
                  >
                    <Transition
                      in={carouselIndex === index}
                      timeout={carouselTransitionDuration}
                    >
                      {state => (
                        <Img
                          fluid={childImageSharp.fluid}
                          imgStyle={{
                            margin: 0,
                            // filter: 'saturate(1.1)'
                            transition: `opacity ${carouselTransitionDuration}ms ease-in-out`,
                            opacity: 0,
                            ...carouselTransitionStyles[state],
                          }}
                          style={{ height: '100%' }}
                        />
                      )}
                    </Transition>
                  </Box>
                )
              })}
              <Flex
                justifyContent="center"
                alignItems="center"
                style={{
                  marginTop: '-8vw',
                  textAlign: 'center',
                }}
              >
                <Heading
                  as="h1"
                  fontSize={[5, 6]}
                  fontWeight="normal"
                  style={{
                    position: 'relative',
                    zIndex: 10,
                    fontFamily: typography.options.bodyFontFamily.join(','),
                    color: 'white',
                    textShadow: `0 0 1vw ${Color('black').fade(0.66)}`,
                  }}
                >
                  <Trans>
                    Vítejte na zubní klinice zabývající se nejen{' '}
                    <strong>estetikou</strong>, ale i{' '}
                    <strong>běžnou péčí</strong> o Vaše zuby
                  </Trans>
                </Heading>
              </Flex>
            </FlexSection>
            {/*<div
              id="about"
              style={{
                ...makePlaceholderStyle(),
                marginTop: '-100vh',
                minHeight: '100vh',
              }}
            >
              About
            </div>*/}
            {/*<div id="services" style={makePlaceholderStyle()}>
              <Heading is="h2" textAlign="center">
                <Trans>Služby</Trans>
              </Heading>
              <p>{faker.lorem.paragraph()}</p>
              <p>{faker.lorem.paragraph()}</p>
              <blockquote>{faker.lorem.paragraph()}</blockquote>
              <p>{faker.lorem.paragraph()}</p>
              <p>{faker.lorem.paragraph()}</p>
              <p>{faker.lorem.paragraph()}</p>
            </div>*/}
            {/*<Gallery
              id="gallery"
              style={{
                ...makePlaceholderStyle(),
                display: 'flex',
                flexDirection: 'column',
                paddingRight: 0,
                paddingBottom: 0,
                paddingLeft: 0,
              }}
            />*/}
            {/*<Flex
              flexDirection="column"
              id="testimonials"
              style={{
                ...makePlaceholderStyle(),
                paddingRight: 0,
                paddingLeft: 0,
              }}
            >
              <Box style={{ margin: '0 15vw' }}>
                <Heading is="h2" textAlign="center">
                  <Trans>Ohlasy</Trans>
                </Heading>
              </Box>
              <Flex flex={1}>
                <AutoPlaySwipeableViews
                  enableMouseEvents
                  interval={10000}
                  style={{ flex: 1 }}
                  containerStyle={{ height: '100%' }}
                  slideStyle={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0 15vw',
                    height: '100%',
                  }}
                >
                  <Testimonial locale={locale} signature={faker.name.findName()}>
                    {faker.lorem.lines()}
                  </Testimonial>
                  <Testimonial locale={locale} signature={faker.name.findName()}>
                    {faker.lorem.lines()}
                  </Testimonial>
                  <Testimonial locale={locale} signature={faker.name.findName()}>
                    {faker.lorem.lines()}
                  </Testimonial>
                </AutoPlaySwipeableViews>
              </Flex>
            </Flex>
            */}
            <BoxSection id="team">
              <Box
                style={{
                  margin: `calc(((126px - 48px) / 2) + 3vw) 0`,
                  textAlign: 'center',
                }}
              >
                <Heading as="h2" fontSize={[5, 6]} fontWeight="normal">
                  <Trans>Tým</Trans>
                </Heading>
              </Box>
              <Box
                mx={[-3, -4]}
                my={5}
                css={{
                  '&:after': {
                    display: 'block',
                    content: '""',
                    clear: 'both',
                  },
                }}
              >
                <Box
                  mb={3}
                  px={[3, 4]}
                  width={[1, 1 / 2, 2 / 3]}
                  style={{ float: 'right' }}
                >
                  <Img fluid={ondrej.childImageSharp.fluid} />
                </Box>
                <Box px={[3, 4]}>
                  <Box my={4}>
                    <Heading as="h3" fontSize={[4, 5]} fontWeight="normal">
                      <Trans>MDDr. Ondřej Klika</Trans>
                    </Heading>
                    <Heading as="h4" my={2} fontSize={[3, 4]}>
                      <Trans>Zubní lékař</Trans>
                    </Heading>
                  </Box>
                  <p>
                    <Trans>
                      Zubní lékař se zkušenostmi v ošetření pomocí CAD/CAM
                      technologie se zaměřením především na estetickou
                      problematiku v zubním lékařství.
                    </Trans>
                  </p>
                  <Heading as="h4" my={2} fontSize={[3, 4]}>
                    <Trans>Vzdělání</Trans>
                  </Heading>
                  <p>
                    <Trans>
                      Vystudoval Univerzitu Palackého v Olomouci, obor zubní
                      lékařství.
                    </Trans>
                  </p>
                  <Heading as="h4" my={2} fontSize={[3, 4]}>
                    <Trans>Silné stránky</Trans>
                  </Heading>
                  <p>
                    <em>
                      <Trans>
                        Mám svou práci rád, protože není nic hezčího než krásný
                        úsměv spokojeného klienta.
                      </Trans>
                    </em>
                  </p>
                  <Heading as="h4" my={2} fontSize={[3, 4]}>
                    <Trans>Motto</Trans>
                  </Heading>
                  <p>
                    <Trans>Per aspera ad astra.</Trans>
                  </p>
                  <CV />
                </Box>
              </Box>
              <Box my={5}>
                <Box my={4}>
                  <Heading as="h3" fontSize={[4, 5]} fontWeight="normal">
                    <Trans>MUDr. Miloš Straka</Trans>
                  </Heading>
                  <Heading as="h4" my={2} fontSize={[3, 4]}>
                    <Trans>Zubní lékař</Trans>
                  </Heading>
                </Box>
                <p>
                  <Trans>
                    Vystudoval Všeobecné zubní lékařství a stomatologii v Hradci
                    Králové. Od roku 2004 pracuje v zaměření především na
                    stomatochirurgii.
                  </Trans>
                </p>
              </Box>
              <Box my={5}>
                <Box my={4}>
                  <Heading as="h3" fontSize={[4, 5]} fontWeight="normal">
                    <Trans>MUDr. Vojtěch Slezáček</Trans>
                  </Heading>
                  <Heading as="h4" my={2} fontSize={[3, 4]}>
                    <Trans>Zubní lékař</Trans>
                  </Heading>
                </Box>
                <p>
                  <Trans>
                    Narodil se v Jindřichově Hradci, vystudoval Lékařskou
                    fakultu Univerzity Palackého v Olomouci a již od roku 1999
                    se úzce specializuje především na obor parodontologie,
                    implantologie a protetika. Pravidělně navštěvuje vzdělávací
                    akce a semináře jak v Čechách, tak v zahraničí. Ve zbytku
                    svého času působí jako parodontologický konzultant v
                    soukromých praxích nejen v Praze, ale v celé České
                    republice.
                  </Trans>
                </p>
              </Box>
              <Box
                mx={[-3, -4]}
                my={5}
                css={{
                  '&:after': {
                    display: 'block',
                    content: '""',
                    clear: 'both',
                  },
                }}
              >
                <Box
                  mb={[3, 0]}
                  px={[3, 4]}
                  width={[1, 1 / 2, 2 / 3]}
                  style={{ float: 'left' }}
                >
                  <Img fluid={erika.childImageSharp.fluid} />
                </Box>
                <Box px={[3, 4]}>
                  <Box my={4}>
                    <Heading as="h3" fontSize={[4, 5]} fontWeight="normal">
                      Erika Čermáková
                    </Heading>
                    <Heading as="h4" my={2} fontSize={[3, 4]}>
                      <Trans>Dentální hygienistka, zubní asistentka</Trans>
                    </Heading>
                  </Box>
                </Box>
              </Box>
              <Box
                mx={[-3, -4]}
                my={5}
                css={{
                  '&:after': {
                    display: 'block',
                    content: '""',
                    clear: 'both',
                  },
                }}
              >
                <Box
                  mb={[3, 0]}
                  px={[3, 4]}
                  width={[1, 1 / 2, 2 / 3]}
                  style={{ float: 'right' }}
                >
                  <Img fluid={diana.childImageSharp.fluid} />
                </Box>
                <Box
                  px={[3, 4]}
                  css={{ '@media (min-width: 768px)': { textAlign: 'right' } }}
                >
                  <Box my={4}>
                    <Heading as="h3" fontSize={[4, 5]} fontWeight="normal">
                      Diana Botlíková
                    </Heading>
                    <Heading as="h4" my={2} fontSize={[3, 4]}>
                      <Trans>Zubní instrumentářka</Trans>
                    </Heading>
                  </Box>
                </Box>
              </Box>
            </BoxSection>
            <BoxSection id="pricing">
              <Box
                style={{
                  padding: `calc(((126px - 48px) / 2) + 3vw) 0`,
                  textAlign: 'center',
                }}
              >
                <Heading as="h2" fontSize={[5, 6]} fontWeight="normal">
                  <Trans>Ceník</Trans>
                </Heading>
              </Box>
              <Pricing locale={locale} />
            </BoxSection>
            <BoxSection id="contact" style={{ paddingBottom: 0 }}>
              <Box
                style={{
                  margin: `calc(((126px - 48px) / 2) + 3vw) 0`,
                  textAlign: 'center',
                }}
              >
                <Heading as="h2" fontSize={[5, 6]} fontWeight="normal">
                  <Trans>Kontakt</Trans>
                </Heading>
              </Box>
              <Flex justifyContent="space-between" style={{ flexWrap: 'wrap' }}>
                <Box width={[1, 1 / 2]}>
                  <Flex mx={-2}>
                    <Box px={2}>
                      <FontAwesomeIcon fixedWidth size="lg" icon="info" />
                    </Box>
                    <Box px={2}>
                      <p>
                        <Trans>Zeptejte se nás, nebo se objednejte</Trans>
                      </p>
                    </Box>
                  </Flex>
                  <ContactForm locale={locale} />
                </Box>
                <Flex mt={[3, 0]} width={[1, 1 / 3]}>
                  <Box>
                    <Flex mx={-2}>
                      <Box px={2}>
                        <FontAwesomeIcon
                          fixedWidth
                          icon="map-marker-alt"
                          size="lg"
                        />
                      </Box>
                      <Box px={2}>
                        <address>
                          <strong>{'Klika Dent'.toUpperCase()}</strong>
                          <br />
                          AFI Karlín (Butterfly)
                          <br />
                          Pernerova 691/42
                          <br />
                          186 00 <Trans>Praha</Trans> 8 – Karlín
                          <br />
                          <Trans>Česká republika</Trans>
                        </address>
                      </Box>
                    </Flex>
                    <Flex mx={-2}>
                      <Box px={2}>
                        <FontAwesomeIcon
                          fixedWidth
                          size="lg"
                          icon="directions"
                        />
                      </Box>
                      <Box px={2}>
                        <p>
                          <Trans>
                            Pro{' '}
                            <a
                              href="https://goo.gl/maps/fCoQWYAc32PjA3Jv8"
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              navigaci
                            </a>
                            , parkování a zastávky MHD se podívejte na mapu
                            níže.
                          </Trans>
                        </p>
                      </Box>
                    </Flex>
                    <Flex mx={-2}>
                      <Box px={2}>
                        <FontAwesomeIcon fixedWidth size="lg" icon="envelope" />
                      </Box>
                      <Box px={2}>
                        <address>
                          <Obfuscate email="info@klikadent.cz" />
                        </address>
                      </Box>
                    </Flex>
                    <Flex mx={-2}>
                      <Box px={2}>
                        <FontAwesomeIcon
                          fixedWidth
                          icon="phone-alt"
                          size="lg"
                        />
                      </Box>
                      <Box px={2}>
                        <address>
                          <Obfuscate
                            tel="+420 226 220 180"
                            style={{ whiteSpace: 'nowrap' }}
                          />
                          <br />
                          <Obfuscate
                            tel="+420 727 974 805"
                            style={{ whiteSpace: 'nowrap' }}
                          />
                        </address>
                      </Box>
                    </Flex>
                  </Box>
                </Flex>
              </Flex>
              <Flex
                mx={-2}
                mt={[0, 5]}
                css={{
                  flexWrap: 'wrap',
                  '@media (min-width: 768px)': {
                    justifyContent: 'center',
                  },
                }}
              >
                <Flex>
                  <Box px={2}>
                    <FontAwesomeIcon fixedWidth icon="clock" size="lg" />
                  </Box>
                  <Box px={2}>
                    <Trans>Ordinační hodiny</Trans>
                    <Hours locale={locale} hours={hours} />
                  </Box>
                </Flex>
                <Box px={[0, 5]} />
                <Flex>
                  <Box px={2}>
                    <FontAwesomeIcon fixedWidth icon="clock" size="lg" />
                  </Box>
                  <Box px={2}>
                    <Trans>Dentální hygiena</Trans>
                    <Hours locale={locale} hours={hoursHygiene} />
                  </Box>
                </Flex>
              </Flex>
              <Flex
                css={{
                  flexWrap: 'wrap',
                  marginTop: '3vw',
                  '@media (max-width: 991.98px)': {
                    marginLeft: -16,
                    marginRight: -16,
                  },
                  '@media (min-width: 992px)': {
                    marginLeft: '-15vw',
                    marginRight: '-15vw',
                  },
                }}
              >
                <Box width={[1]} style={{ height: '66vh' }}>
                  <LazyLoad once>
                    <Map
                      containerElement={<div style={{ height: '100%' }} />}
                    />
                  </LazyLoad>
                </Box>
                {/* <Box width={[1, 1 / 2]}>
                  <Img
                    fluid={clinicEnterance.childImageSharp.fluid}
                    imgStyle={{ objectPosition: 'center 35%' }}
                    style={{ height: '66vh' }}
                  />
                </Box> */}
              </Flex>
              <Flex mx={-2} mt={4} mb={2} style={{ flexWrap: 'wrap' }}>
                <Flex css={{ '@media (min-width: 768px)': { flex: 1 } }}>
                  <Box px={2}>
                    <FontAwesomeIcon fixedWidth icon="map" size="lg" />
                  </Box>
                  <Box px={2}>
                    <p>
                      <Trans>
                        Ordinace se nachází v severovýchodním křídle budovy
                        Butterfly, v přízemním podlaží.
                      </Trans>
                    </p>
                  </Box>
                </Flex>
                <Box px={2} style={{ flex: 3 }}>
                  <DetailedMap />
                </Box>
              </Flex>
              <Flex mx={-2} mt={4} mb={2}>
                <Box px={2}>
                  <FontAwesomeIcon fixedWidth icon="parking" size="lg" />
                </Box>
                <Box px={2} mb={6}>
                  <p>
                    <Trans>
                      Parkování je možné na rezervovaných místech pro naše
                      klienty nebo na volných místech za budovou. Další možností
                      je placené parkování v “bílé” zóně v okolí objektu. Pokud
                      byste měli problém zaparkovat, prosím{' '}
                      <Obfuscate tel="+420 226 220 180">informujte</Obfuscate>{' '}
                      recepci naší ordinace, rádi vám pomohou.
                    </Trans>
                  </p>
                </Box>
              </Flex>
            </BoxSection>
          </>
        )}
      </I18n>
    </Layout>
  )
}

export default IndexPage
